// extracted by mini-css-extract-plugin
export default {"container":"App_container__Rt8T2","left":"App_left__yierV","right":"App_right__TxKjn"};